var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2023 Félix Robles <felix@sequentech.io>
// SPDX-FileCopyrightText: 2023, 2024 Eduardo Robles <edu@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import { DatagridConfigurable, List, TextField, TextInput, BooleanField, WrapperField, useRefresh, useNotify, useGetList, FunctionField, Button as ReactAdminButton, useRecordContext, BooleanInput, DateInput, useSidebarState, useUnselectAll, useListContext, } from "react-admin";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { useTenantStore } from "@/providers/TenantContextProvider";
import UploadIcon from "@mui/icons-material/Upload";
import { ListActions } from "@/components/ListActions";
import { Box, Button, Chip, Menu, MenuItem, Skeleton, Stack, Typography } from "@mui/material";
import { Dialog, theme } from "@sequentech/ui-essentials";
import { useTranslation } from "react-i18next";
import EditIcon from "@mui/icons-material/Edit";
import MailIcon from "@mui/icons-material/Mail";
import CreditScoreIcon from "@mui/icons-material/CreditScore";
import PasswordIcon from "@mui/icons-material/Password";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import FilterAlt from "@mui/icons-material/FilterAlt";
import { EditUser } from "./EditUser";
import { AudienceSelection, SendTemplate } from "./SendTemplate";
import { CreateUser } from "./CreateUser";
import { AuthContext } from "@/providers/AuthContextProvider";
import { DELETE_USER } from "@/queries/DeleteUser";
import { MANUAL_VERIFICATION } from "@/queries/ManualVerification";
import { useMutation, useQuery } from "@apollo/client";
import { IPermissions } from "@/types/keycloak";
import { ResourceListStyles } from "@/components/styles/ResourceListStyles";
import { translate } from "@sequentech/ui-core";
import { SettingsContext } from "@/providers/SettingsContextProvider";
import { ImportDataDrawer } from "@/components/election-event/import-data/ImportDataDrawer";
import { FormStyles } from "@/components/styles/FormStyles";
import { EXPORT_USERS } from "@/queries/ExportUsers";
import { EXPORT_TENANT_USERS } from "@/queries/ExportTenantUsers";
import { DownloadDocument } from "./DownloadDocument";
import { IMPORT_USERS } from "@/queries/ImportUsers";
import { ElectoralLogFilters, ElectoralLogList } from "@/components/ElectoralLogList";
import { USER_PROFILE_ATTRIBUTES } from "@/queries/GetUserProfileAttributes";
import { getTranslationLabel, userBasicInfo } from "@/services/UserService";
import CustomDateField from "./CustomDateField";
import { ListActionsMenu } from "@/components/ListActionsMenu";
import EditPassword from "./EditPassword";
import { styled } from "@mui/material/styles";
import eStyled from "@emotion/styled";
import { DELETE_USERS } from "@/queries/DeleteUsers";
import { ETasksExecution } from "@/types/tasksExecution";
import { useWidgetStore } from "@/providers/WidgetsContextProvider";
import SelectArea from "@/components/area/SelectArea";
import { useElectionEventTallyStore } from "@/providers/ElectionEventTallyProvider";
import { UserActionTypes } from "@/components/types";
import { useUsersPermissions } from "./useUsersPermissions";
import { Check, FilterAltOff } from "@mui/icons-material";
import { useLocation } from "react-router-dom";
import { getPreferenceKey } from "@/lib/helpers";
import { isEqual } from "lodash";
import { AuthorizedElectionsField } from "./AuthrizedElectionsField";
export var AUTHORIZED_ELECTION_IDS = "authorized-election-ids";
var DataGridContainerStyle = styled(DatagridConfigurable, {
    shouldForwardProp: function (prop) { return prop !== "isOpenSideBar"; }, // Prevent `isOpenSideBar` from being passed to the DOM
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    @media (min-width: ", "px) {\n        overflowx: auto;\n        width: 100%;\n        ", "\n        &  > div:first-of-type {\n            position: absolute;\n            width: 100%;\n        }\n    }\n"], ["\n    @media (min-width: ", "px) {\n        overflowx: auto;\n        width: 100%;\n        ", "\n        &  > div:first-of-type {\n            position: absolute;\n            width: 100%;\n        }\n    }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.values.md;
}, function (_a) {
    var isOpenSideBar = _a.isOpenSideBar;
    return "maxWidth: ".concat(isOpenSideBar ? "calc(100vw - 355px)" : "calc(100vw - 108px)", ";");
});
var StyledChip = styled(Chip)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    margin: 4px;\n"], ["\n    margin: 4px;\n"])));
var StyledNull = eStyled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: block;\n    padding-left: 18px;\n"], ["\n    display: block;\n    padding-left: 18px;\n"])));
export var ListUsers = function (_a) {
    var _b;
    var _c;
    var aside = _a.aside, electionEventId = _a.electionEventId, electionId = _a.electionId;
    var _d = useTranslation(), t = _d.t, i18n = _d.i18n;
    var tenantId = useTenantStore()[0];
    var globalSettings = useContext(SettingsContext).globalSettings;
    var isOpenSidebar = useSidebarState()[0];
    var location = useLocation();
    var _e = useState(false), open = _e[0], setOpen = _e[1];
    var _f = useState(false), openExport = _f[0], setOpenExport = _f[1];
    var _g = useState(false), exporting = _g[0], setExporting = _g[1];
    var _h = useState(null), userType = _h[0], setUserType = _h[1];
    var _j = useState(), exportDocumentId = _j[0], setExportDocumentId = _j[1];
    var _k = useState(false), openNew = _k[0], setOpenNew = _k[1];
    var _l = useState(AudienceSelection.SELECTED), audienceSelection = _l[0], setAudienceSelection = _l[1];
    var _m = useState(null), documentId = _m[0], setDocumentId = _m[1];
    var _o = useWidgetStore(), addWidget = _o[0], setWidgetTaskId = _o[1], updateWidgetFail = _o[2];
    var _p = React.useState(false), openUsersLogsModal = _p[0], setOpenUsersLogsModal = _p[1];
    var _q = React.useState(false), openSendTemplate = _q[0], setOpenSendTemplate = _q[1];
    var _r = React.useState(false), openDeleteModal = _r[0], setOpenDeleteModal = _r[1];
    var _s = React.useState(false), openManualVerificationModal = _s[0], setOpenManualVerificationModal = _s[1];
    var _t = React.useState(false), openDeleteBulkModal = _t[0], setOpenDeleteBulkModal = _t[1];
    var _u = React.useState(false), openEditPassword = _u[0], setOpenEditPassword = _u[1];
    var _v = useState([]), selectedIds = _v[0], setSelectedIds = _v[1];
    var _w = useState(), deleteId = _w[0], setDeleteId = _w[1];
    var _x = useState(false), openDrawer = _x[0], setOpenDrawer = _x[1];
    var _y = useState(false), openImportDrawer = _y[0], setOpenImportDrawer = _y[1];
    var _z = useState([]), recordIds = _z[0], setRecordIds = _z[1];
    var _0 = useState(), userRecord = _0[0], setUserRecord = _0[1];
    var authContext = useContext(AuthContext);
    var refresh = useRefresh();
    var unselectAll = useUnselectAll("user");
    var deleteUser = useMutation(DELETE_USER)[0];
    var getManualVerificationPdf = useMutation(MANUAL_VERIFICATION)[0];
    var deleteUsers = useMutation(DELETE_USERS)[0];
    var exportUsers = useMutation(EXPORT_USERS)[0];
    var PHONE_NUMBER_USER_ATTRIBUTE = "sequent.read-only.mobile-number";
    var userAttributes = useQuery(USER_PROFILE_ATTRIBUTES, {
        variables: {
            tenantId: tenantId,
            electionEventId: electionEventId,
        },
    }).data;
    var Filters = useMemo(function () {
        var filters = [];
        if (userAttributes === null || userAttributes === void 0 ? void 0 : userAttributes.get_user_profile_attributes) {
            filters = userAttributes.get_user_profile_attributes.map(function (attr) {
                var _a, _b;
                //covert to valid source string (if attr name is for example sequent.read-only.otp-method)
                var source = (_a = attr.name) === null || _a === void 0 ? void 0 : _a.replaceAll(".", "%");
                if (((_b = attr.annotations) === null || _b === void 0 ? void 0 : _b.inputType) === "html5-date") {
                    return (_jsx(DateInput, { source: "attributes.".concat(attr.name), label: getTranslationLabel(attr.name, attr.display_name, t) }, attr.name));
                }
                return (_jsx(TextInput, { source: userBasicInfo.includes("".concat(attr.name))
                        ? "".concat(attr.name, ".IsLike")
                        : "attributes.".concat(source), label: getTranslationLabel(attr.name, attr.display_name, t) }, attr.name));
            });
            filters.push(_jsx(BooleanInput, { source: "enabled" }, "enabled"));
            filters.push(_jsx(BooleanInput, { source: "email_verified" }, "email_verified"));
            if (electionEventId) {
                filters.push(_jsx(SelectArea, { tenantId: tenantId, electionEventId: electionEventId, source: "attributes.area-id", label: t("usersAndRolesScreen.users.fields.area") }));
            }
            if (electionEventId) {
                filters.push(_jsx(BooleanInput, { source: "has_voted", label: t("usersAndRolesScreen.users.fields.has_voted") }, "has_voted"));
            }
        }
        return filters;
    }, [userAttributes === null || userAttributes === void 0 ? void 0 : userAttributes.get_user_profile_attributes]);
    var exportTenantUsers = useMutation(EXPORT_TENANT_USERS, {
        context: {
            headers: {
                "x-hasura-role": IPermissions.USER_READ,
            },
        },
    })[0];
    var notify = useNotify();
    var rolesList = useGetList("role", {
        pagination: { page: 1, perPage: 9999 },
        sort: { field: "last_updated_at", order: "DESC" },
        filter: {
            tenant_id: tenantId,
        },
    }).data;
    /**
     * Permissions
     */
    var _1 = useUsersPermissions(), canImportUsers = _1.canImportUsers, canCreateVoters = _1.canCreateVoters, canEditVoters = _1.canEditVoters, canEditVotersEmailTlf = _1.canEditVotersEmailTlf, canDeleteVoters = _1.canDeleteVoters, canImportVoters = _1.canImportVoters, canExportVoters = _1.canExportVoters, canManuallyVerify = _1.canManuallyVerify, canChangePassword = _1.canChangePassword, showVotersColumns = _1.showVotersColumns, showVotersFilters = _1.showVotersFilters, showVotersLogs = _1.showVotersLogs, canSendTemplates = _1.canSendTemplates;
    /**
     * Permissions
     */
    var handleClose = function () {
        setRecordIds([]);
        setOpenUsersLogsModal(false);
        setOpenSendTemplate(false);
        setOpenDeleteModal(false);
        setOpenManualVerificationModal(false);
        setOpenDeleteBulkModal(false);
        setOpenDrawer(false);
        setOpenNew(false);
        setOpen(false);
        unselectAll();
    };
    var editAction = function (id) {
        setOpen(true);
        setOpenNew(false);
        setOpenDeleteModal(false);
        setOpenManualVerificationModal(false);
        setOpenDeleteBulkModal(false);
        setOpenSendTemplate(false);
        setRecordIds([id]);
    };
    var sendTemplateForIdAction = function (id) {
        sendTemplateAction([id]);
    };
    var sendTemplateAction = function (ids, audienceSelection) {
        if (audienceSelection === void 0) { audienceSelection = AudienceSelection.SELECTED; }
        setOpen(false);
        setOpenNew(false);
        setOpenDeleteModal(false);
        setOpenManualVerificationModal(false);
        setOpenDeleteBulkModal(false);
        setOpenSendTemplate(true);
        setAudienceSelection(audienceSelection);
        setRecordIds(ids);
    };
    var deleteAction = function (id) {
        if (!electionEventId && authContext.userId === id) {
            return;
        }
        setOpen(false);
        setOpenNew(false);
        setOpenSendTemplate(false);
        setOpenManualVerificationModal(false);
        setOpenDeleteBulkModal(false);
        setOpenDeleteModal(true);
        setDeleteId(id);
    };
    var manualVerificationAction = function (id) {
        if (!electionEventId && authContext.userId === id) {
            return;
        }
        setOpen(false);
        setOpenNew(false);
        setOpenSendTemplate(false);
        setOpenManualVerificationModal(true);
        setOpenDeleteBulkModal(false);
        setOpenDeleteModal(false);
        setRecordIds([id]);
    };
    var editPasswordAction = function (id) {
        setOpen(false);
        setOpenNew(false);
        setOpenSendTemplate(false);
        setOpenManualVerificationModal(false);
        setOpenDeleteBulkModal(false);
        setOpenDeleteModal(false);
        setOpenEditPassword(true);
        setRecordIds([id]);
    };
    var confirmManualVerificationAction = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, errors, data, docId;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, getManualVerificationPdf({
                        variables: {
                            tenantId: tenantId,
                            electionEventId: electionEventId,
                            voterId: recordIds[0],
                        },
                    })];
                case 1:
                    _a = _c.sent(), errors = _a.errors, data = _a.data;
                    if (errors) {
                        console.log("Error manually verifying user: ".concat(errors));
                        notify(t("usersAndRolesScreen.voters.notifications.manualVerificationError"), {
                            type: "error",
                        });
                        setRecordIds([]);
                        setOpenManualVerificationModal(false);
                        refresh();
                        return [2 /*return*/];
                    }
                    console.log("fetchData success: ".concat(data));
                    setRecordIds([]);
                    refresh();
                    docId = (_b = data === null || data === void 0 ? void 0 : data.get_manual_verification_pdf) === null || _b === void 0 ? void 0 : _b.document_id;
                    if (docId) {
                        setDocumentId(docId);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var confirmDeleteAction = function () { return __awaiter(void 0, void 0, void 0, function () {
        var errors;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, deleteUser({
                        variables: {
                            tenantId: tenantId,
                            electionEventId: electionEventId,
                            userId: deleteId,
                        },
                    })];
                case 1:
                    errors = (_a.sent()).errors;
                    if (errors) {
                        notify(t("usersAndRolesScreen.".concat(electionEventId ? "voters" : "users", ".notifications.deleteError")), { type: "error" });
                        console.log("Error deleting user: ".concat(errors));
                        return [2 /*return*/];
                    }
                    notify(t("usersAndRolesScreen.".concat(electionEventId ? "voters" : "users", ".notifications.deleteSuccess")), { type: "success" });
                    setDeleteId(undefined);
                    refresh();
                    return [2 /*return*/];
            }
        });
    }); };
    var showUsersLogsModal = function (id) {
        if (!electionEventId) {
            return;
        }
        setOpen(false);
        setOpenNew(false);
        setOpenSendTemplate(false);
        setOpenManualVerificationModal(false);
        setOpenDeleteBulkModal(false);
        setOpenDeleteModal(false);
        setOpenUsersLogsModal(true);
        setRecordIds([id]);
    };
    var actionsConfig = (_b = {},
        _b[UserActionTypes.COMMUNICATION] = {
            icon: _jsx(MailIcon, {}),
            action: sendTemplateForIdAction,
            showAction: function () { return canSendTemplates; },
            label: t("sendCommunication.send"),
        },
        _b[UserActionTypes.EDIT] = {
            icon: _jsx(EditIcon, { className: "edit-voter-icon" }),
            action: editAction,
            showAction: function () { return canEditVoters || canEditVotersEmailTlf; },
            label: t("common.label.edit"),
            saveRecordAction: setUserRecord,
        },
        _b[UserActionTypes.DELETE] = {
            icon: _jsx(DeleteIcon, { className: "delete-voter-icon" }),
            action: deleteAction,
            showAction: function () { return canDeleteVoters; },
            label: t("common.label.delete"),
            className: "delete-voter-icon",
        },
        _b[UserActionTypes.MANUAL_VERIFICATION] = {
            icon: _jsx(CreditScoreIcon, {}),
            action: manualVerificationAction,
            showAction: function () { return canManuallyVerify; },
            label: t("usersAndRolesScreen.voters.manualVerification.label"),
            saveRecordAction: setUserRecord,
        },
        _b[UserActionTypes.PASSWORD] = {
            icon: _jsx(PasswordIcon, {}),
            action: editPasswordAction,
            showAction: function () { return canChangePassword; },
            label: t("usersAndRolesScreen.editPassword.label"),
        },
        _b[UserActionTypes.LOGS] = {
            icon: _jsx(VisibilityIcon, {}),
            action: showUsersLogsModal,
            showAction: function () { return showVotersLogs; },
            label: t("usersAndRolesScreen.voters.logs.label"),
        },
        _b);
    var actionByUserType = {
        user: [
            UserActionTypes.COMMUNICATION,
            UserActionTypes.EDIT,
            UserActionTypes.DELETE,
            UserActionTypes.PASSWORD,
        ],
        voter: [
            UserActionTypes.COMMUNICATION,
            UserActionTypes.EDIT,
            UserActionTypes.DELETE,
            UserActionTypes.MANUAL_VERIFICATION,
            UserActionTypes.PASSWORD,
            UserActionTypes.LOGS,
        ],
    };
    function getActionsForUserType(userType) {
        var actionsByUserType = actionByUserType[userType] || [];
        var actions = actionsByUserType.map(function (actionType) { return actionsConfig[actionType]; });
        return actions;
    }
    var actions = useMemo(function () {
        var userType = electionEventId ? "voter" : "user";
        return getActionsForUserType(userType);
    }, [electionEventId]);
    function confirmDeleteBulkAction() {
        return __awaiter(this, void 0, void 0, function () {
            var errors;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, deleteUsers({
                            variables: {
                                tenantId: tenantId,
                                electionEventId: electionEventId,
                                usersId: selectedIds,
                            },
                        })];
                    case 1:
                        errors = (_a.sent()).errors;
                        if (errors) {
                            notify(t("usersAndRolesScreen.".concat(electionEventId ? "voters" : "users", ".notifications.deleteError")), { type: "error" });
                            return [2 /*return*/];
                        }
                        notify(t("usersAndRolesScreen.".concat(electionEventId ? "voters" : "users", ".notifications.multipleDeleteSuccess")), { type: "success" });
                        refresh();
                        return [2 /*return*/];
                }
            });
        });
    }
    // @ts-ignore
    function BulkActions(props) {
        return (_jsxs(_Fragment, { children: [canSendTemplates && (_jsxs(Button, __assign({ variant: "actionbar", onClick: function () {
                        var _a;
                        sendTemplateAction((_a = props.selectedIds) !== null && _a !== void 0 ? _a : [], AudienceSelection.SELECTED);
                    } }, { children: [_jsx(ResourceListStyles.MailIcon, {}), t("sendCommunication.send")] }), "send-notification")), canDeleteVoters && (_jsxs(Button, __assign({ variant: "actionbar", onClick: function () {
                        setSelectedIds(props.selectedIds);
                        setOpenDeleteBulkModal(true);
                    } }, { children: [_jsx(ResourceListStyles.DeleteIcon, {}), t("common.label.delete")] })))] }));
    }
    var handleImport = function () {
        setOpenImportDrawer(true);
    };
    var handleExport = function () {
        setExporting(false);
        setExportDocumentId(undefined);
        setOpenExport(true);
    };
    var confirmExportAction = function () { return __awaiter(void 0, void 0, void 0, function () {
        var currWidget, _a, exportUsersData, errors, task_id, _b, exportUsersData, errors, documentId_1, err_1;
        var _c, _d, _e;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    _f.trys.push([0, 5, , 6]);
                    setExportDocumentId(undefined);
                    setExporting(true);
                    if (!electionEventId) return [3 /*break*/, 2];
                    currWidget = addWidget(ETasksExecution.EXPORT_VOTERS, undefined);
                    return [4 /*yield*/, exportUsers({
                            variables: { tenantId: tenantId, electionEventId: electionEventId, electionId: electionId },
                        })];
                case 1:
                    _a = _f.sent(), exportUsersData = _a.data, errors = _a.errors;
                    if (errors || !exportUsersData) {
                        setExporting(false);
                        setOpenExport(false);
                        updateWidgetFail(currWidget.identifier);
                        return [2 /*return*/];
                    }
                    task_id = (_d = (_c = exportUsersData === null || exportUsersData === void 0 ? void 0 : exportUsersData.export_users) === null || _c === void 0 ? void 0 : _c.task_execution) === null || _d === void 0 ? void 0 : _d.id;
                    task_id
                        ? setWidgetTaskId(currWidget.identifier, task_id)
                        : updateWidgetFail(currWidget.identifier);
                    setExporting(false);
                    setOpenExport(false);
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, exportTenantUsers({
                        variables: { tenantId: tenantId },
                    })];
                case 3:
                    _b = _f.sent(), exportUsersData = _b.data, errors = _b.errors;
                    if (errors || !exportUsersData) {
                        setExporting(false);
                        setOpenExport(false);
                        notify(t("usersAndRolesScreen.".concat("users", ".notifications.exportError")), {
                            type: "error",
                        });
                        return [2 /*return*/];
                    }
                    documentId_1 = (_e = exportUsersData.export_tenant_users) === null || _e === void 0 ? void 0 : _e.document_id;
                    setExportDocumentId(documentId_1);
                    _f.label = 4;
                case 4: return [3 /*break*/, 6];
                case 5:
                    err_1 = _f.sent();
                    console.log(err_1);
                    currWidget && updateWidgetFail(currWidget.identifier);
                    return [3 /*break*/, 6];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var Empty = function () { return (_jsxs(ResourceListStyles.EmptyBox, { children: [_jsx(Typography, __assign({ variant: "h4", paragraph: true }, { children: t("usersAndRolesScreen.".concat(electionEventId ? "voters" : "users", ".emptyHeader")) })), canCreateVoters ? (_jsxs(_Fragment, { children: [_jsx(Typography, __assign({ variant: "body1", paragraph: true }, { children: t("usersAndRolesScreen.".concat(electionEventId ? "voters" : "users", ".askCreate")) })), _jsxs(ResourceListStyles.EmptyButtonList, __assign({ className: "voter-add-button" }, { children: [_jsxs(Button, __assign({ onClick: function () { return setOpenNew(true); } }, { children: [_jsx(ResourceListStyles.CreateIcon, { icon: faPlus }), t("usersAndRolesScreen.".concat(electionEventId ? "voters" : "users", ".create.subtitle"))] })), _jsx(ReactAdminButton, __assign({ onClick: handleImport, label: t("common.label.import") }, { children: _jsx(UploadIcon, {}) }))] }))] })) : null] })); };
    var electionEvent = useRecordContext();
    var importUsers = useMutation(IMPORT_USERS)[0];
    /**
     * added custom filter actions menu
     */
    var buttonRef = useRef(null);
    // state
    var _2 = useState([
        canSendTemplates ? (_jsxs(Button, __assign({ onClick: function () {
                sendTemplateAction([], AudienceSelection.ALL_USERS);
            } }, { children: [_jsx(ResourceListStyles.MailIcon, {}), t("sendCommunication.send")] }), "send-notification")) : (_jsx(_Fragment, {})),
    ]), listActions = _2[0], setListActions = _2[1];
    var _3 = useState(null), anchorEl = _3[0], setAnchorEl = _3[1];
    var _4 = useState(false), openCustomMenu = _4[0], setOpenCustomMenu = _4[1];
    var customFilter = useElectionEventTallyStore().customFilter;
    var _5 = useState({}), myFilters = _5[0], setMyFilters = _5[1];
    var _6 = useState(false), hasCustomFilter = _6[0], setHasCustomFilter = _6[1];
    var _7 = useState(null), selectedCustomItemMenu = _7[0], setSelectedCustomItemMenu = _7[1];
    // functions
    var handleClickCustomMenu = function (event) {
        setAnchorEl(event.currentTarget);
        setOpenCustomMenu(true);
    };
    var handleCloseCustomMenu = function () {
        setAnchorEl(null);
        setOpenCustomMenu(false);
    };
    var handleApplyCustomMenu = function (filter, index) {
        if (filter) {
            setMyFilters(function (prev) { return (__assign({}, filter)); });
            setHasCustomFilter(true);
        }
        else {
            setMyFilters({});
            setHasCustomFilter(false);
        }
        setSelectedCustomItemMenu(index);
        setAnchorEl(null);
        setOpenCustomMenu(false);
    };
    // effect
    useEffect(function () {
        setMyFilters(customFilter);
        setHasCustomFilter(false);
    }, [customFilter]);
    var permanentFilters = {
        tenant_id: tenantId,
        election_event_id: electionEventId,
        election_id: electionId,
    };
    useEffect(function () {
        var _a;
        if (electionEvent) {
            var customFilters = ((_a = electionEvent === null || electionEvent === void 0 ? void 0 : electionEvent.presentation) === null || _a === void 0 ? void 0 : _a.custom_filters) || [];
            if (customFilters.length > 0) {
                customFilters = __spreadArray([], customFilters, true);
                setListActions(function (prev) {
                    // prevent double adding the button
                    var customFilterExists = prev.some(function (action) { return action.key === "custom-filters"; });
                    // if it's not in the list of actions, add it
                    if (!customFilterExists) {
                        return __spreadArray(__spreadArray([], prev, true), [
                            _jsxs(Button, __assign({ ref: buttonRef, disableElevation: true, "aria-controls": openCustomMenu ? "basic-menu" : undefined, "aria-haspopup": "true", "aria-expanded": openCustomMenu ? "true" : undefined, variant: "contained", onClick: function (e) {
                                    var _a;
                                    handleClickCustomMenu(e);
                                    (_a = buttonRef.current) === null || _a === void 0 ? void 0 : _a.blur();
                                }, style: {
                                    backgroundColor: hasCustomFilter ? "#0F054C" : "#FFFFFF",
                                    color: hasCustomFilter ? "#FFFFFF" : "#0F054C",
                                } }, { children: [hasCustomFilter ? (_jsx(FilterAlt, { sx: { mr: 1 } })) : (_jsx(FilterAltOff, { sx: { mr: 1 } })), t("common.label.filter")] }), "custom-filters"),
                        ], false);
                    }
                    return prev;
                });
            }
        }
    }, [electionEvent]);
    // Force update when hasCustomFilter changes
    useEffect(function () {
        setListActions(function (prev) {
            return prev.map(function (action) {
                if (action.key === "custom-filters") {
                    return (_jsxs(Button, __assign({ ref: buttonRef, disableElevation: true, "aria-controls": openCustomMenu ? "basic-menu" : undefined, "aria-haspopup": "true", "aria-expanded": openCustomMenu ? "true" : undefined, variant: "contained", onClick: function (e) {
                            var _a;
                            handleClickCustomMenu(e);
                            (_a = buttonRef.current) === null || _a === void 0 ? void 0 : _a.blur();
                        }, style: {
                            backgroundColor: hasCustomFilter ? "#0F054C" : "#FFFFFF",
                            color: hasCustomFilter ? "#FFFFFF" : "#0F054C",
                        } }, { children: [hasCustomFilter ? (_jsx(FilterAlt, { sx: { mr: 1 } })) : (_jsx(FilterAltOff, { sx: { mr: 1 } })), t("common.label.filter")] }), "custom-filters"));
                }
                return action;
            });
        });
    }, [hasCustomFilter]);
    // Direct DOM manipulation for background color
    useEffect(function () {
        if (buttonRef.current) {
            buttonRef.current.style.backgroundColor = hasCustomFilter ? "#0F054C" : "#FFFFFF";
            buttonRef.current.style.color = hasCustomFilter ? "#FFFFFF" : "#0F054C";
        }
    }, [hasCustomFilter, theme.palette.primary]);
    var resetMenuItem = function () {
        // renders the reset custom menu item
        return (_jsx(MenuItem, __assign({ onClick: function () { return handleApplyCustomMenu(null, null); } }, { children: _jsxs(Stack, __assign({ direction: "row", alignItems: "center" }, { children: [_jsx("span", { style: { width: "32px" } }), _jsxs("span", { children: [t("electionEventScreen.common.reset"), " "] })] })) }), "reset-menu-item"));
    };
    /**
     * END added custom filter actions menu
     */
    var renderMenuItems = function () {
        var _a;
        var customFiltersList = [];
        var customFilters = ((_a = electionEvent === null || electionEvent === void 0 ? void 0 : electionEvent.presentation) === null || _a === void 0 ? void 0 : _a.custom_filters) || [];
        if (customFilters.length > 0) {
            // build the list of available filters
            customFiltersList = customFilters.map(function (item, index) {
                var label = item.label, filter = item.filter;
                return (_jsx(MenuItem, __assign({ onClick: function () { return handleApplyCustomMenu(filter, index + 1); } }, { children: _jsxs(Stack, __assign({ direction: "row", alignItems: "center" }, { children: [_jsx("span", __assign({ style: { width: "32px" } }, { children: selectedCustomItemMenu && selectedCustomItemMenu === index + 1 ? (_jsx(Check, { sx: { mr: 1 } })) : null })), _jsx("span", { children: translate(label.i18n, i18n.language.split("-")[0], i18n.language.split("-")[0]) || t(label.name) })] })) }), "custom-filter-".concat(index)));
            });
        }
        return __spreadArray([resetMenuItem()], customFiltersList, true);
    };
    var handleImportVoters = function (documentId, sha256) { return __awaiter(void 0, void 0, void 0, function () {
        var currWidget, _a, data, errors, task_id, err_2;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    setOpenImportDrawer(false);
                    currWidget = addWidget(ETasksExecution.IMPORT_USERS, undefined);
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, importUsers({
                            variables: {
                                tenantId: tenantId,
                                documentId: documentId,
                                electionEventId: electionEventId || undefined,
                                sha256: sha256,
                            },
                        })];
                case 2:
                    _a = _c.sent(), data = _a.data, errors = _a.errors;
                    task_id = (_b = data === null || data === void 0 ? void 0 : data.import_users) === null || _b === void 0 ? void 0 : _b.task_execution.id;
                    setWidgetTaskId(currWidget.identifier, task_id);
                    refresh();
                    if (errors) {
                        updateWidgetFail(currWidget.identifier);
                        notify(t("electionEventScreen.import.importVotersError"), { type: "error" });
                    }
                    return [3 /*break*/, 4];
                case 3:
                    err_2 = _c.sent();
                    console.log("Tenant ID: ".concat(tenantId));
                    console.log("Document ID: ".concat(documentId));
                    console.log("Election Event ID: ".concat(electionEvent.id));
                    console.log("");
                    console.log("Error importing voters: ".concat(err_2));
                    updateWidgetFail(currWidget.identifier);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var listFields = useMemo(function () {
        var basicInfoFields = [];
        var attributesFields = [];
        var omitFields = ["id", "email_verified", "email"];
        userAttributes === null || userAttributes === void 0 ? void 0 : userAttributes.get_user_profile_attributes.forEach(function (attr) {
            if (attr.name && userBasicInfo.includes(attr.name)) {
                basicInfoFields.push(attr);
            }
            else {
                omitFields.push("attributes['".concat(attr.name, "']"));
                attributesFields.push(attr);
            }
        });
        return { basicInfoFields: basicInfoFields, attributesFields: attributesFields, omitFields: omitFields };
    }, [userAttributes === null || userAttributes === void 0 ? void 0 : userAttributes.get_user_profile_attributes]);
    var renderFields = function (fields) {
        var allFields = fields.map(function (attr) {
            var _a;
            if (attr.name === AUTHORIZED_ELECTION_IDS)
                return null;
            if (((_a = attr.annotations) === null || _a === void 0 ? void 0 : _a.inputType) === "html5-date") {
                return (_jsx(FunctionField, { source: "attributes['".concat(attr.name, "']"), label: getTranslationLabel(attr.name, attr.display_name, t), render: function (record, source) {
                        return (_jsx(CustomDateField, { base: "attributes", source: "".concat(attr.name), label: getTranslationLabel(attr.name, attr.display_name, t), emptyText: "-" }, attr.name));
                    } }, attr.name));
            }
            else if (attr.multivalued) {
                return (_jsx(FunctionField, { label: getTranslationLabel(attr.name, attr.display_name, t), render: function (record, source) {
                        var value = attr.name && userBasicInfo.includes(attr.name)
                            ? record[attr.name]
                            : (attr === null || attr === void 0 ? void 0 : attr.name)
                                ? record.attributes[attr === null || attr === void 0 ? void 0 : attr.name]
                                : "-";
                        return (_jsx(_Fragment, { children: value ? (value.map(function (item, index) { return (_jsx(StyledChip, { label: item }, index)); })) : (_jsx(StyledNull, { children: "-" })) }));
                    } }, attr.name));
            }
            return (_jsx(TextField, { source: attr.name && userBasicInfo.includes(attr.name)
                    ? attr.name
                    : "attributes['".concat(attr.name, "']"), label: getTranslationLabel(attr.name, attr.display_name, t), emptyText: "-" }, attr.name));
        });
        localStorage.removeItem("RaStore.preferences.".concat(getPreferenceKey(location.pathname, "voters"), ".datagrid.availableColumns"));
        return allFields;
    };
    useEffect(function () {
        if (location.pathname.includes("user-roles")) {
            setUserType("user");
        }
        else {
            setUserType("voter");
        }
    }, [location.pathname]);
    var checkUserEmailAndPhoneNumber = function () {
        if (userRecord) {
            var email = userRecord === null || userRecord === void 0 ? void 0 : userRecord.email;
            var phoneNumber = userRecord === null || userRecord === void 0 ? void 0 : userRecord.attributes[PHONE_NUMBER_USER_ATTRIBUTE];
            if (email || phoneNumber) {
                return true;
            }
        }
        return false;
    };
    var checkIsVoted = function (record) {
        var _a;
        return ((_a = record === null || record === void 0 ? void 0 : record.votes_info) === null || _a === void 0 ? void 0 : _a.length)
            ? !electionId || record.votes_info.some(function (vote) { return vote.election_id === electionId; })
            : false;
    };
    var CustomListBody = function () {
        // `isLoading` => initial load, `isFetching` => subsequent loads (e.g. paging, filtering)
        var _a = useListContext(), isLoading = _a.isLoading, isFetching = _a.isFetching, perPage = _a.perPage, filterValues = _a.filterValues, page = _a.page, data = _a.data;
        // Keep track of the "previous" page/filters in a ref and whether they changed
        var prevStateRef = useRef({ perPage: perPage, page: page, filterValues: filterValues });
        var _b = useState(false), filtersChanged = _b[0], setFiltersChanged = _b[1];
        // 1. Compare current page and filters with previous
        //    Detect when filters/page change, and set filtersChanged=true
        useEffect(function () {
            var prev = prevStateRef.current;
            var changed = prev.perPage !== perPage ||
                prev.page !== page ||
                !isEqual(prev.filterValues, filterValues);
            if (changed) {
                setFiltersChanged(true);
            }
            prevStateRef.current = { perPage: perPage, page: page, filterValues: filterValues };
        }, [perPage, page, filterValues]);
        // 2. Detect when the fetch is complete so we can reset filtersChanged if it was set
        useEffect(function () {
            if (!isFetching && filtersChanged) {
                setFiltersChanged(false);
            }
        }, [isFetching, filtersChanged]);
        var hasAuthorizedElectionIdsAttributes = useMemo(function () {
            return userAttributes === null || userAttributes === void 0 ? void 0 : userAttributes.get_user_profile_attributes.find(function (attr) { return attr.name === AUTHORIZED_ELECTION_IDS; });
        }, [userAttributes === null || userAttributes === void 0 ? void 0 : userAttributes.get_user_profile_attributes]);
        if (isLoading || (isFetching && filtersChanged)) {
            return _jsx(TableSkeleton, { rowCount: perPage });
        }
        return (_jsxs(_Fragment, { children: [(userAttributes === null || userAttributes === void 0 ? void 0 : userAttributes.get_user_profile_attributes) && (_jsxs(DataGridContainerStyle, __assign({ preferenceKey: getPreferenceKey(location.pathname, "voters"), omit: listFields.omitFields, isOpenSideBar: isOpenSidebar, bulkActionButtons: _jsx(BulkActions, {}) }, { children: [_jsx(TextField, { source: "id", sx: { display: "block", width: "280px" } }), _jsx(BooleanField, { source: "email_verified", label: t("usersAndRolesScreen.users.fields.emailVerified") }), _jsx(BooleanField, { source: "enabled", label: t("usersAndRolesScreen.users.fields.enabled") }), renderFields(listFields.basicInfoFields), electionEventId && (_jsx(FunctionField, { label: t("usersAndRolesScreen.users.fields.area"), render: function (record) {
                                var _a, _b, _c;
                                return ((_a = record === null || record === void 0 ? void 0 : record.area) === null || _a === void 0 ? void 0 : _a.name) ? (_jsx(Chip, { label: (_c = (_b = record === null || record === void 0 ? void 0 : record.area) === null || _b === void 0 ? void 0 : _b.name) !== null && _c !== void 0 ? _c : "" })) : ("-");
                            } })), electionEventId && hasAuthorizedElectionIdsAttributes && (_jsx(FunctionField, { label: t("usersAndRolesScreen.users.fields.authorized-election-ids"), render: function () { return (_jsx(AuthorizedElectionsField, { electionEventId: electionEventId })); } })), renderFields(listFields.attributesFields), electionEventId && (_jsx(FunctionField, { source: "has_voted", label: t("usersAndRolesScreen.users.fields.has_voted"), render: function (record, source) {
                                var newRecord = __assign({ has_voted: checkIsVoted(record) }, record);
                                return _jsx(BooleanField, { record: newRecord, source: source });
                            } })), !canEditVoters &&
                            !canDeleteVoters &&
                            !canSendTemplates &&
                            !canManuallyVerify &&
                            !canChangePassword &&
                            !showVotersLogs ? null : (_jsx(WrapperField, __assign({ source: "actions", label: "Actions" }, { children: _jsx(ListActionsMenu, { actions: actions }) })))] }))), showVotersFilters && (_jsx(Menu, __assign({ id: "custom-filters-menu", anchorEl: anchorEl, open: openCustomMenu, onClose: handleCloseCustomMenu, MenuListProps: {
                        "aria-labelledby": "basic-button",
                    } }, { children: renderMenuItems() })))] }));
    };
    return (_jsxs(_Fragment, { children: [_jsx(List, __assign({ resource: "user", storeKey: "".concat(getPreferenceKey(location.pathname, "voters")), queryOptions: {
                    refetchInterval: globalSettings.QUERY_POLL_INTERVAL_MS,
                }, empty: hasCustomFilter ? false : _jsx(Empty, {}), actions: _jsx(ListActions, { withColumns: showVotersColumns, preferenceKey: getPreferenceKey(location.pathname, "voters"), withFilter: showVotersFilters, withImport: userType
                        ? userType === "voter"
                            ? canImportVoters
                            : canImportUsers
                        : false, doImport: handleImport, withExport: canExportVoters, doExport: handleExport, isExportDisabled: openExport, open: openDrawer, setOpen: setOpenDrawer, Component: _jsx(CreateUser, { electionEventId: electionEventId, close: handleClose, rolesList: rolesList || [], userAttributes: (userAttributes === null || userAttributes === void 0 ? void 0 : userAttributes.get_user_profile_attributes) || [] }), withComponent: canCreateVoters, extraActions: __spreadArray([], listActions, true) }), filter: __assign(__assign({}, myFilters), permanentFilters), aside: aside, filters: Filters, disableSyncWithLocation: true }, { children: _jsx(CustomListBody, {}) })), _jsx(ResourceListStyles.Drawer, __assign({ anchor: "right", open: open, onClose: handleClose }, { children: _jsx(EditUser, { id: recordIds[0], electionEventId: electionEventId, electionId: electionId, close: handleClose, rolesList: rolesList || [], userAttributes: (userAttributes === null || userAttributes === void 0 ? void 0 : userAttributes.get_user_profile_attributes) || [], record: userRecord }) })), _jsx(ResourceListStyles.Drawer, __assign({ anchor: "right", open: openSendTemplate, onClose: handleClose }, { children: _jsx(SendTemplate, { ids: recordIds, audienceSelection: audienceSelection, electionEventId: electionEventId, close: handleClose }) })), _jsx(ResourceListStyles.Drawer, __assign({ anchor: "right", open: openNew, onClose: handleClose }, { children: _jsx(CreateUser, { electionEventId: electionEventId, close: handleClose, rolesList: rolesList || [], userAttributes: (userAttributes === null || userAttributes === void 0 ? void 0 : userAttributes.get_user_profile_attributes) || [] }) })), _jsx(Dialog, __assign({ variant: "warning", open: openDeleteModal, ok: t("common.label.delete"), cancel: t("common.label.cancel"), title: t("common.label.warning"), handleClose: function (result) {
                    if (result) {
                        confirmDeleteAction();
                    }
                    setOpenDeleteModal(false);
                } }, { children: t("usersAndRolesScreen.".concat(electionEventId ? "voters" : "users", ".delete.body")) })), _jsxs(Dialog, __assign({ variant: "warning", open: openManualVerificationModal, okEnabled: function () {
                    return checkUserEmailAndPhoneNumber() && !documentId;
                }, ok: t("usersAndRolesScreen.voters.manualVerification.verify"), cancel: t("common.label.cancel"), title: t("common.label.warning"), errorMessage: checkUserEmailAndPhoneNumber()
                    ? undefined
                    : t("usersAndRolesScreen.voters.manualVerification.noEmailOrPhone"), handleClose: function (result) {
                    if (result) {
                        confirmManualVerificationAction();
                        return;
                    }
                    setOpenManualVerificationModal(false);
                } }, { children: [t("usersAndRolesScreen.voters.manualVerification.body"), _jsxs(FormStyles.ReservedProgressSpace, { children: [documentId ? _jsx(FormStyles.ShowProgress, {}) : null, documentId ? (_jsx(DownloadDocument, { documentId: documentId, electionEventId: electionEventId !== null && electionEventId !== void 0 ? electionEventId : "", fileName: "manual-verify-".concat(electionEventId, "-").concat(documentId, ".pdf"), onDownload: function () {
                                    console.log("onDownload called");
                                    notify(t("usersAndRolesScreen.voters.notifications.manualVerificationSuccess"), {
                                        type: "success",
                                    });
                                    setOpenManualVerificationModal(false);
                                    setDocumentId(null);
                                } })) : null] })] })), _jsx(ImportDataDrawer, { open: openImportDrawer, closeDrawer: function () { return setOpenImportDrawer(false); }, title: "electionEventScreen.import.title", subtitle: "electionEventScreen.import.subtitle", paragraph: "electionEventScreen.import.votersParagraph", doImport: handleImportVoters, errors: null }), _jsx(Dialog, __assign({ variant: "warning", open: openDeleteBulkModal, ok: t("common.label.delete"), cancel: t("common.label.cancel"), title: t("common.label.warning"), handleClose: function (result) {
                    if (result) {
                        confirmDeleteBulkAction();
                    }
                    setOpenDeleteBulkModal(false);
                    unselectAll();
                } }, { children: t("usersAndRolesScreen.".concat(electionEventId ? "voters" : "users", ".delete.bulkBody")) })), _jsxs(Dialog, __assign({ variant: "info", open: openExport, ok: t("common.label.export"), okEnabled: function () { return !exporting; }, cancel: t("common.label.cancel"), title: t("common.label.export"), handleClose: function (result) {
                    if (result) {
                        confirmExportAction();
                    }
                    else {
                        setExportDocumentId(undefined);
                        setExporting(false);
                        setOpenExport(false);
                    }
                } }, { children: [t("common.export"), _jsxs(FormStyles.ReservedProgressSpace, { children: [exporting ? _jsx(FormStyles.ShowProgress, {}) : null, exporting && exportDocumentId ? (_jsx(DownloadDocument, { documentId: exportDocumentId, electionEventId: electionEventId !== null && electionEventId !== void 0 ? electionEventId : "", fileName: "users-export.csv", onDownload: function () {
                                    console.log("onDownload called");
                                    setExportDocumentId(undefined);
                                    setExporting(false);
                                    setOpenExport(false);
                                } })) : null] })] })), _jsx(Dialog, __assign({ fullWidth: true, variant: "info", maxWidth: "xl", title: t("usersAndRolesScreen.voters.logs.label"), ok: t("common.label.close"), open: openUsersLogsModal, handleClose: handleClose }, { children: recordIds && recordIds.length > 0 && (_jsx(ElectoralLogList, { electionEventId: electionEventId, showActions: false, filterToShow: ElectoralLogFilters.USER_ID, filterValue: (_c = recordIds[0]) === null || _c === void 0 ? void 0 : _c.toString() })) })), openEditPassword && (_jsx(EditPassword, { open: openEditPassword, handleClose: function () { return setOpenEditPassword(false); }, id: recordIds[0], electionEventId: electionEventId }))] }));
};
export var TableSkeleton = function (_a) {
    var _b = _a.rowCount, rowCount = _b === void 0 ? 10 : _b, _c = _a.columnWidths, columnWidths = _c === void 0 ? ["10%", "20%", "20%", "10%", "15%", "25%"] : _c;
    return (_jsx(Box, __assign({ sx: { width: "100%", p: 2 } }, { children: Array.from({ length: rowCount }).map(function (_, rowIndex) { return (_jsx(Box, __assign({ sx: { display: "flex", gap: 2, mb: 1, alignItems: "center" } }, { children: columnWidths.map(function (width, colIndex) { return (_jsx(Skeleton, { variant: "text", sx: { width: width, height: 24 } }, "".concat(rowIndex, "-").concat(colIndex))); }) }), rowIndex)); }) })));
};
var templateObject_1, templateObject_2, templateObject_3;
